import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Headline, Paragraph } from 'ViatoUi/Shared/Typo';
import Scrollable from 'ViatoUi/Shared/Utilities/Scrollable';

import styles from './ComparisonTable.module.scss';

const ComparisonTable = () => {
	const { t } = useTranslation('contractGenerator');

	const isInitialOpen = JSON.parse(document.getElementById('viato-contract-generator').dataset?.comparisonTableIsOpen || false);

	const [isVisible, setIsVisible] = useState(isInitialOpen);
	const [isActive, setActive] = useState(!isInitialOpen);
	const [isActive2, setActive2] = useState(!isInitialOpen);
	const [isActive3, setActive3] = useState(!isInitialOpen);

	const handleToggle = () => {
		setActive(!isActive);
	};
	const handleToggle2 = () => {
		setActive2(!isActive2);
	};
	const handleToggle3 = () => {
		setActive3(!isActive3);
	};

	return (
		<div className={styles.comparisonTable}>
			<FlexBox alignItems='center' className={styles.header} justifyContent='center' onClick={() => setIsVisible(!isVisible)}>
				<Icon
					className={(styles.icon, styles.dropdown_pointer)}
					color='dark'
					icon={isVisible ? 'fa-chevron-up' : 'fa-chevron-down'}
					iconWeight='fal'
					size='xl'
				/>
				<Spacer width='m' />
				<Headline className={styles.dropdown_pointer} type='h5'>
					{t('layouts.comparisonTable.mainHeadline')}
				</Headline>
			</FlexBox>

			{isVisible && (
				<>
					<Spacer height='l' />
					<Scrollable className={styles.scrollable}>
						<FlexBox flexDirection='column'>
							<FlexBox className={styles.accordion_box} flexDirection='column'>
								<div className={styles.comparisontable_header}>
									<div className={styles.ul}>
										<div className={styles.li} />
										<div className={styles.li}>
											<div className={styles.span}>
												<Headline type='h5'>{t('layouts.comparisonTable.bookingEngine')}</Headline>
											</div>
										</div>
										<div className={styles.li}>
											<div className={styles.span}>
												<Headline type='h5'>{t('layouts.comparisonTable.channelManager')}</Headline>
											</div>
										</div>
										<div className={styles.li}>
											<div className={styles.span}>
												<Headline type='h5'>{t('layouts.comparisonTable.kickStarter')}</Headline>
											</div>
											<div className={styles.span}>
												<Headline type='h5'>{t('layouts.comparisonTable.upToRooms')}</Headline>
											</div>
										</div>
										<div className={styles.li}>
											<div className={styles.span}>
												<Headline type='h5'>{t('layouts.comparisonTable.suitePro')}</Headline>
											</div>
										</div>
									</div>
								</div>
								<div className={styles.accordion_wrap}>
									<div
										aria-hidden='true'
										className={styles.accordion_item}
										data-visible={isActive}
										onClick={handleToggle}
									>
										<div className={styles.ul}>
											<div className={styles.li}>
												<div className={styles.accordion_title}>
													<Icon
														className={styles.icon}
														color='dark'
														icon={isActive ? 'fa-chevron-down' : 'fa-chevron-up'}
														iconWeight='fal'
													/>
													<Headline type='h5'>{t('layouts.comparisonTable.channelManager')}</Headline>
												</div>
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' /> **
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
									</div>
									<div className={styles.accordion_item_content}>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.connectionToPortals')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>{t('layouts.comparisonTable.unlimited')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.upTo')} 10</div>
											<div className={styles.li}>{t('layouts.comparisonTable.unlimited')}</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.rates')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.unlimited')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.unlimited')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.catAdditionalRate')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.multiPropertyHandling')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.userManagement')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.priceInheritanceSubrates')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.individualPortalSurcharges')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.dailyRestrictionMaintenance')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>{t('layouts.comparisonTable.resItems')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.resItemsLess')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.resItems')}</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.dailyChannelRateSplitting')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.autoRateControl')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.detailedXChangeXReports')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.promotions')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.promocode')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.taskmanagerOptional')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
									</div>

									<div
										aria-hidden='true'
										className={styles.accordion_item}
										data-visible={isActive2}
										onClick={handleToggle2}
									>
										<div className={styles.ul}>
											<div className={styles.li}>
												<div className={styles.accordion_title}>
													<Icon
														className={styles.icon}
														color='dark'
														icon={isActive2 ? 'fa-chevron-down' : 'fa-chevron-up'}
														iconWeight='fal'
													/>
													<Headline type='h5'>{t('layouts.comparisonTable.bookingEngine')}</Headline>
												</div>
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' /> **
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
									</div>
									<div className={styles.accordion_item_content}>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.design')}</div>
											<div className={styles.li}>
												{t('layouts.comparisonTable.beCiGuests')}
												<br />
												{t('layouts.comparisonTable.beCiPages')}
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>{t('layouts.comparisonTable.beCiGuestsAlt')}</div>
											<div className={styles.li}>
												{t('layouts.comparisonTable.beCiGuests')}
												<br />
												{t('layouts.comparisonTable.beCiPages')}
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.packagesArrangements')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.additionalServices')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.childSupplements')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.dailyChildSupplements')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>{t('layouts.comparisonTable.fixedChildSupplements')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.dailyChildSupplements')}</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.paymentProvider')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.connectVariousPaymentProvider')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.paymentProviderStripe')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.connectVariousPaymentProvider')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.connectVariousPaymentProvider')}</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.pricecheckOptional')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.promocode')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='darkSmoke' icon='fa-times' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
									</div>

									<div
										aria-hidden='true'
										className={styles.accordion_item}
										data-visible={isActive3}
										onClick={handleToggle3}
									>
										<div className={styles.ul}>
											<div className={styles.li}>
												<div className={styles.accordion_title}>
													<Icon
														className={styles.icon}
														color='dark'
														icon={isActive3 ? 'fa-chevron-down' : 'fa-chevron-up'}
														iconWeight='fal'
													/>
													<Headline type='h5'>{t('layouts.comparisonTable.setupSupport')}</Headline>
												</div>
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' /> **
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
									</div>
									<div className={styles.accordion_item_content}>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.support')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.phoneEmailSupport')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.phoneEmailSupport')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.freePhoneEmailSupport')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.phoneEmailSupport')}</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.onboarding')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.persSetup')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.persSetupExpert')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.fullServiceKickstarterSetup')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.persSetupExpert')}</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.onlineTraining')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.profTraining')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.profTraining')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.profTraining')}</div>
											<div className={styles.li}>{t('layouts.comparisonTable.profTrainingTwo')}</div>
										</div>
										<div className={styles.ul}>
											<div className={styles.li}>{t('layouts.comparisonTable.freeTutorial')}</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
											<div className={styles.li}>
												<Icon className={styles.icon} color='dark' icon='fa-check' iconWeight='fal' />
											</div>
										</div>
									</div>
								</div>
							</FlexBox>
						</FlexBox>
					</Scrollable>
					<Spacer height='xl' />
					<Paragraph color='silver' font='normal' centered>
						{t('layouts.comparisonTable.restrictionDetails')}
					</Paragraph>
				</>
			)}
		</div>
	);
};

export default ComparisonTable;
